module.exports = __webpack_public_path__ + "media/assets/images/SYB_FDay2022_Menu_Banner_B-d053b3eb27a20cfd719c7a9d050dfe1c.jpg";